import { setCssVariable } from '@utilities/css-custom-props';
import { debounce } from '@utilities/throttle';

export default class QuoteAuthorPlugin {
  dom: HTMLElement;

  constructor(dom: HTMLElement) {
    this.dom = dom;
  }

  init() {
    this.setBackgroundForVerticalDivider();
    this.removeNonBreakingSpacing();
    window.addEventListener('resize', this.setBackgroundForVerticalDivider);
    window.addEventListener('orientationchange', this.setBackgroundForVerticalDivider);
  }

  detach() {
    window.removeEventListener('resize', this.setBackgroundForVerticalDivider);
    window.removeEventListener('orientationchange', this.setBackgroundForVerticalDivider);
  }

  setBackgroundForVerticalDivider = debounce(() => {
    const quotes = this.dom.querySelectorAll('.js-quote');
    quotes.forEach((wrapper) => {
      const verticalDivider = wrapper.querySelector<HTMLElement>('.vertical-divider');
      const paragraphAuthor = wrapper.querySelector<HTMLElement>('.paragraph-author');

      // Check if .paragraph-author exists in the current qutoe element
      if (paragraphAuthor) {
        const authorHeight = paragraphAuthor.clientHeight;
        setCssVariable('author-height', `${authorHeight}px`, verticalDivider);
      }
    });
  });

  removeNonBreakingSpacing = debounce(() => {
    const nonBreakingSpaceElements = this.dom.querySelectorAll('h2');
    nonBreakingSpaceElements.forEach((element) => {
      if (element.textContent.includes('\u00a0')) {
        element.textContent.replaceAll('\u00a0', '&nbsp;');
      }
    });
  });
}
